import { get, set, del } from 'idb-keyval';

const ASSET_PREFIX = 'sds_asset_';

export interface StoredAsset {
  id: string;
  name: string;
  mimeType: string;
  blob: Blob;
  dataUrl: string;
  createdAt: string;
}

/**
 * Stores a binary image/file asset into IndexedDB
 */
export async function storeAsset(file: File | Blob, name: string): Promise<StoredAsset> {
  const id = `asset-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 7)}`;
  const dataUrl = await blobToDataUrl(file);

  const asset: StoredAsset = {
    id,
    name,
    mimeType: file.type || 'application/octet-stream',
    blob: file,
    dataUrl,
    createdAt: new Date().toISOString(),
  };

  await set(`${ASSET_PREFIX}${id}`, asset);
  return asset;
}

/**
 * Retrieves an asset by ID from IndexedDB
 */
export async function getAsset(id: string): Promise<StoredAsset | null> {
  try {
    return (await get<StoredAsset>(`${ASSET_PREFIX}${id}`)) || null;
  } catch {
    return null;
  }
}

/**
 * Removes an asset from IndexedDB
 */
export async function removeAsset(id: string): Promise<void> {
  await del(`${ASSET_PREFIX}${id}`);
}

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
